export const guanggao_price_list = ['次', '天', '周', '月', '期']